import { css } from '@emotion/react';
import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
    display:flex;
    flex-direction: column;
    width: 100%
    // margin: 0 100px 100px;
       margin-bottom: 100px;
 @media (max-width: 768px) {
   text-align:center;
   justify-content:center;
   align-items:center;
  }
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;
  justify-content: left;
  @media (max-width: 768px) {
    font-size:25px;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 50px;
   color:#91abb3;
   display:flex;
   justify-content: left;
  @media (max-width: 768px) {
    font-size:12px;
  }
`;

const IframeWrapper= styled.div`
    width: 100vw;
    max-width: 100%;
    height: 80vh;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
    margin: 0 auto;
`;

const iframeStyle = css`
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
`;

const errorTextStyle = css`
    font-size: 16px;
    color: red;
    text-align: center;
    margin-top: 10px;
`;



const PanoramaViewer = ({ panorama }) => {

    const { i18n } = useTranslation();

    return (
        <Container>
          <Title>{i18n.t('panoramicView')}</Title>
          <Description>{i18n.t('panoramicViewDescription')}</Description>
                  <IframeWrapper>
                      <iframe
                          src={panorama}
                          style={{ width: "100%", height: "100%", border: "none", display: "block" }}
                          allow="fullscreen"
                      />
                      </IframeWrapper>
        </Container>

    );
};



export default PanoramaViewer;



